import { render, staticRenderFns } from "./ListAndRegistry.vue?vue&type=template&id=aba2baaa&scoped=true"
import script from "./ListAndRegistry.vue?vue&type=script&lang=js"
export * from "./ListAndRegistry.vue?vue&type=script&lang=js"
import style0 from "./ListAndRegistry.vue?vue&type=style&index=0&id=aba2baaa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba2baaa",
  null
  
)

export default component.exports